const Footer = () => {
  const thisYear = new Date().getFullYear();
  const buildHash = import.meta.env.VITE_BUILD_GIT_COMMIT_HASH ?? "0000000";
  const buildDate = import.meta.env.VITE_BUILD_DATE ?? 0;

  return (
    <>
      <div className="Footer">
        &copy; {thisYear} Matt Pass Ltd, Registered in England No: 09699045. 124 City Road, London EC1V 2NX
        <br />
        Build Hash: {buildHash} @ {buildDate}
      </div>
    </>
  );
};

export default Footer;
